import {
	breadTheme,
	ModalProvider,
	payPlanTheme,
	threeDotDough,
	ToastProvider,
} from "@getbread/dough";
import type { Theme } from "@mui/material";
import { ApiClientProvider } from "./apiClientProvider";
import { AppContainer } from "./components/AppContainer/AppContainer.style";
import { AuthenticationProvider } from "./components/AuthenticationProvider";
import { GlobalErrorContext } from "./components/errors/GlobalErrorContext";
import { LocaleProvider } from "./components/LocaleProvider";
import { ThemeProvider } from "./global.style";
import { RootPage } from "./pages/RootPage";
import { getConfig } from "./utils/getConfig";
import { FeatureFlagProvider } from "./components/FeatureFlagProvider";

const themeName = getConfig("themename");

const themes: Record<string, Theme> = {
	breadTheme,
	payPlanTheme,
	threeDotDough,
};

const App = () => {
	return (
		<FeatureFlagProvider>
			<LocaleProvider>
				<ThemeProvider theme={themes[themeName]!}>
					<ApiClientProvider>
						<AuthenticationProvider>
							<ToastProvider>
								<ModalProvider>
									<AppContainer id="app">
										<RootPage />
										<GlobalErrorContext />
									</AppContainer>
								</ModalProvider>
							</ToastProvider>
						</AuthenticationProvider>
					</ApiClientProvider>
				</ThemeProvider>
			</LocaleProvider>
		</FeatureFlagProvider>
	);
};

export { App };
